import "./StatusBadge.scss"

// StatusBadge (SPEC-022 F2 / K3) — ONE uniform badge box for every LIMS QC status, modelled on
// the original Pass/Fail flag (the `.ResultEntryPanel-flag .is-pass/.is-fail` visual family).
// Statuses across the QC lifecycle — raw judgement, reviewer action, QA decision — are now
// rendered as the SAME badge component so the GMP decision chain reads consistently wherever it
// appears (the per-sample card header AND the QA decisions table).
//
// `variant` selects the colour family:
//   pass     — green  (effective Pass / QA Approved)
//   fail     — red    (raw Fail / QA Stopped)
//   pending  — grey   (not yet judged)
//   info     — blue   (QA Rerun / rerun-link references)
//   warn     — amber  (OOT / in-review / sent-to-qa reviewer-stage states)
//   neutral  — slate  (generic informational marker)
// `title` is an optional hover tooltip (e.g. an OOT comment). Children are the badge label.
export default function StatusBadge({ variant = "neutral", title, className = "", children }) {
  const extra = className ? ` ${className}` : ""
  const cls = `LimsStatusBadge is-${variant}${extra}`
  return (
    <span className={cls} title={title || undefined}>
      {children}
    </span>
  )
}

// StatusBadgeStack (K3) — vertical column of badges forming the decision chain for one sample:
// row 1 raw judgement → row 2 reviewer action → row 3 QA decision. Empty rows are simply not
// rendered (a sample only has the rows its lifecycle has reached).
export function StatusBadgeStack({ className = "", children }) {
  const extra = className ? ` ${className}` : ""
  return <span className={`LimsStatusBadgeStack${extra}`}>{children}</span>
}
